import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-side-menu',
  templateUrl: 'side-menu.component.html'
})
export class SideMenuComponent {}
